(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["spec-lab"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){ document.querySelectorAll('.sl-root').forEach(initSpecLab); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();

  function initSpecLab(root){
    if(root.dataset.slInit) return; root.dataset.slInit='1';
    "use strict";
    var RM=(typeof matchMedia==='function') && matchMedia('(prefers-reduced-motion:reduce)').matches;

    var DATA;
    try{ DATA=JSON.parse(root.querySelector('.sl-skis').textContent); }catch(e){ DATA=[]; }
    var CMP={};
    try{ var cmpEl=root.querySelector('.sl-cmp'); if(cmpEl && cmpEl.textContent.trim()){ CMP=JSON.parse(cmpEl.textContent); } }catch(e){ CMP={}; }
    if(!Object.keys(CMP).length && window.SPEC_LAB_COMPARISONS){ CMP=window.SPEC_LAB_COMPARISONS; }

    var LETTERS=['A','B','C'];
    var cap=function(s){return s?s.charAt(0).toUpperCase()+s.slice(1):s;};

    /* rich-text metafields can arrive as {"type":"root",...} JSON or as HTML.
       Extract plain text, then take the first segment before a "|". */
    function richToText(v){
      if(!v) return '';
      v=String(v).trim();
      /* rich text (full or fragment): grab the first text node's value */
      if(v.indexOf('"value"')>=0){
        var m=v.match(/"value"\s*:\s*"([^"]*)"/) || v.match(/"value"\s*:\s*"(.*)$/);
        if(m) return m[1].replace(/\\"/g,'"').replace(/\s+/g,' ').trim();
      }
      /* HTML or plain text */
      return v.replace(/<[^>]+>/g,'').replace(/\s+/g,' ').trim();
    }
    var firstSeg=function(v){return richToText(v).split('|')[0].trim();};
    var _dec=document.createElement('textarea');
    function decodeEntities(s){ if(!s||String(s).indexOf('&')<0) return s||''; _dec.innerHTML=String(s); return _dec.value; }
    var titleCore=function(s){
      if(!s) return '';
      s=String(s).replace(/\s*wood\s*core\s*$/i,'').replace(/\s*core\s*$/i,'').trim();
      return s.toLowerCase().replace(/\b\w/g,function(c){return c.toUpperCase();});
    };

    function profOf(t){t=(t||'').toLowerCase();
      if(t.indexOf('triple')>=0)return'triple';
      if(t.indexOf('mustache')>=0)return'mustache';
      if(t.indexOf('front')>=0)return'front';
      if(t.indexOf('twin')>=0)return'twin';
      if(t.indexOf('full rocker')>=0||t.indexOf('handlebar')>=0)return'powder';
      return'other';}
    function catOf(camType,gender){
      var base={triple:'All-Mountain',mustache:'All-Mtn Playful',front:'All-Mtn Charger',twin:'Park',powder:'Powder',other:'All-Mountain'}[profOf(camType)];
      return base+(gender==='women'?' · W':'');}

    function parseDims(html){
      var out={tip:null,waist:null,tail:null,sizes:[],mount:null,plt:{}};
      if(!html) return out;
      var doc=new DOMParser().parseFromString(html,'text/html');
      var rows=doc.querySelectorAll('tbody tr');
      if(!rows.length) rows=doc.querySelectorAll('tr');
      rows.forEach(function(tr){
        var cells=[].slice.call(tr.children).map(function(td){return td.textContent.trim();});
        if(cells.length<4) return;
        var L=parseInt(cells[0],10); if(!L) return;
        out.sizes.push(L);
        if(out.tip===null){ out.tip=parseInt(cells[1],10); out.waist=parseInt(cells[2],10); out.tail=parseInt(cells[3],10); }
        var rad=parseFloat(cells[4]), edge=parseInt(cells[5],10), wt=parseFloat(cells[6]);
        out.plt[L]=[isNaN(rad)?null:rad, isNaN(edge)?null:edge, isNaN(wt)?null:wt.toFixed(1)];
        var mt=parseFloat(cells[7]); if(!isNaN(mt)) out.mount=mt;
      });
      return out;
    }

    var SKIS={}, ORDER=[];
    DATA.forEach(function(r){
      var d=parseDims(r.dims);
      var isTour=/tour/i.test(r.handle);
      SKIS[r.handle]={
        handle:r.handle, name:r.name, url:r.url, price:r.price, compareAt:r.compareAt||0, tagline:decodeEntities(firstSeg(r.tagline)),
        big:r.img, med:r.img, twoup:r.img2||null,
        camName:r.camType||'Camber Profile', camImg:r.camImg||'', camDesc:decodeEntities(r.camDesc||''),
        prof:profOf(r.camType), isTour:isTour,
        tip:d.tip, waist:d.waist, tail:d.tail,
        sizes:d.sizes.length?d.sizes:[], mount:d.mount, plt:d.plt,
        core:titleCore(r.core), cat:catOf(r.camType,r.gender),
        family:((r.name||'').replace(/\s+\d.*$/,'').trim())||r.name
      };
      ORDER.push(r.handle);
    });

    if(!ORDER.length){
      var cols=root.querySelector('.sl-cols');
      if(cols) cols.innerHTML='<div style="grid-column:1/-1;padding:24px;color:#c5cecc;border:1px solid rgba(255,255,255,.12);font-size:14px">Spec Lab: no ski data loaded (the <b>spec-lab</b> collection returned 0 products, or the data block failed to parse). Raw length: '+(root.querySelector('.sl-skis')?root.querySelector('.sl-skis').textContent.trim().length:'n/a')+' chars.</div>';
      return;
    }

    var getCmp=function(a,b){return CMP[[a,b].sort().join('|')]||null;};

    /* state */
    var DEF=['deathwish-112','wildcat-108','countach-104'].filter(function(h){return SKIS[h];});
    for(var qi=0; qi<ORDER.length && DEF.length<3; qi++){ if(DEF.indexOf(ORDER[qi])<0) DEF.push(ORDER[qi]); }
    var slots=DEF.slice(0,3);
    var midSize=function(h){var s=SKIS[h]?SKIS[h].sizes:[]; return s.length?(s[Math.floor(s.length/2)]):0;};
    var len=slots.map(midSize);

    var $=function(s){return root.querySelector(s);};
    var dims=function(k){return (k.tip!=null)?(k.tip+' · '+k.waist+' · '+k.tail):'—';};
    var radius=function(k,L){return k.plt&&k.plt[L]?k.plt[L][0]:null;};
    var esc=function(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');};

    function optionsFor(sel){
      return ORDER.map(function(h){var taken=h!==sel&&slots.indexOf(h)>=0;return '<option value="'+h+'" '+(h===sel?'selected':'')+(taken?' disabled':'')+'>'+esc(SKIS[h].name)+(taken?' (already selected)':'')+'</option>';}).join('');
    }
    var lenOptions=function(k,c){return k.sizes.map(function(s){return '<option value="'+s+'" '+(s===c?'selected':'')+'>'+s+' cm</option>';}).join('');};

    /* ---------- columns ---------- */
    function renderCols(){
      $('.sl-cols').innerHTML=slots.map(function(h,i){
        var k=SKIS[h],L=len[i],pl=k.plt&&k.plt[L];
        return '<div class="col" data-col="'+i+'">'+
          '<div class="picker"><div class="prow">'+
            '<div class="selwrap"><select data-slot="'+i+'" aria-label="Choose ski '+LETTERS[i]+'">'+optionsFor(h)+'</select></div>'+
            '<div class="selwrap len"><select data-len="'+i+'" aria-label="Length">'+lenOptions(k,L)+'</select></div>'+
          '</div></div>'+
          '<div class="closeup" data-cu="'+i+'" title="Hover to zoom">'+
            '<img src="'+esc(k.twoup||k.big)+'" alt="'+esc(k.name)+' detail" data-fb="'+esc(k.med)+'" referrerpolicy="no-referrer" onerror="window.__slImgFB(this)">'+
            '<span class="scrub">Hover → Zoom</span>'+
          '</div>'+
          '<div class="cbody">'+
            '<div class="cname">'+esc(k.name)+'<span class="pr">'+(k.compareAt&&k.compareAt>k.price?'<del>$'+k.compareAt+'</del> ':'')+'$'+k.price+'</span></div>'+
            '<div class="ctag">'+esc(k.tagline)+'</div>'+
            '<div class="camtag"><i></i>'+esc(k.camName)+'</div>'+
          '</div>'+
          '<div class="specs">'+
            '<div class="sp"><span class="k">Tip · Waist · Tail</span><span class="v">'+dims(k)+'</span></div>'+
            '<div class="sp"><span class="k">Sidecut radius</span><span class="v '+(pl?'':'dim')+'">'+(pl&&pl[0]!=null?pl[0]+' m':'—')+'</span></div>'+
            '<div class="sp"><span class="k">Effective edge</span><span class="v '+(pl?'':'dim')+'">'+(pl&&pl[1]!=null?pl[1]+' mm':'—')+'</span></div>'+
            '<div class="sp"><span class="k">Weight / pair</span><span class="v '+(pl?'':'dim')+'">'+(pl&&pl[2]!=null?pl[2]+' lb':'—')+'</span></div>'+
            '<div class="sp"><span class="k">Mount</span><span class="v '+(k.mount!=null?'':'dim')+'">'+(k.mount!=null?k.mount+' cm':'—')+'</span></div>'+
            '<div class="sp"><span class="k">Core</span><span class="v '+(k.core?'':'dim')+'">'+(k.core?esc(k.core):'—')+'</span></div>'+
          '</div>'+
          '<div class="cact"><a href="'+esc(k.url)+'" target="_blank" rel="noopener">View '+esc(k.name)+' →</a></div>'+
        '</div>';
      }).join('');
    }

    /* ---------- camber stack ---------- */
    function renderCamber(){
      $('.sl-camber').innerHTML=slots.map(function(h,i){
        var k=SKIS[h];
        var overlay='<span class="camhint">Hover → Details</span><div class="cdesc-hover">'+esc(k.camDesc)+'</div>';
        var graphic = k.camImg
          ? '<div class="img" data-profname="'+esc(k.camName)+'" data-profdesc="'+esc(k.camDesc)+'"><img src="'+esc(k.camImg)+'" alt="'+esc(k.camName)+' camber profile" loading="lazy" referrerpolicy="no-referrer" onerror="window.__slCamFB(this)">'+overlay+'</div>'
          : '<div class="img" data-profname="'+esc(k.camName)+'" data-profdesc="'+esc(k.camDesc)+'"><div class="camph"><span>'+esc(k.camName)+'</span></div>'+overlay+'</div>';
        return '<div class="crow" data-crow="'+i+'">'+
          '<div class="crow-head">'+esc(k.name)+' - '+esc(k.camName)+'</div>'+
          '<div class="crow-body">'+
            '<div class="cdesc-col">'+esc(k.camDesc)+'</div>'+
            graphic+
          '</div>'+
        '</div>';
      }).join('');
    }

    /* ---------- "how it stacks up" ---------- */
    function pickLine(text, ski, isFocus){
      var reason=String(text).replace(/^For\s+/i,'').replace(/,?\s*check out the .*$/i,'').trim();
      return '<div class="pick'+(isFocus?' focus':'')+'"><a class="pk" style="border-bottom:2px solid #ff4c5e !important;text-decoration:none !important;padding-bottom:1px" href="'+esc(ski.url)+'">Pick the '+esc(ski.name)+'</a> for '+esc(reason)+'.</div>';
    }
    function renderStacks(){
      var pairs=[[0,1],[0,2],[1,2]];
      var blocks=pairs.map(function(pr){
        var A=SKIS[slots[pr[0]]], B=SKIS[slots[pr[1]]], c=getCmp(A.handle,B.handle), inner;
        if(A.handle===B.handle){
          inner='<div class="cmp-missing">You’ve picked the same ski in both spots — these are the same model.</div>';
        } else if(c){
          var ap=c.pick[A.handle], bp=c.pick[B.handle];
          inner='<div class="cmp-body">'+c.body.map(function(p){return '<p>'+esc(p)+'</p>';}).join('')+'</div>'+
            '<div class="cmp-picks">'+(ap?pickLine(ap,A,false):'')+(bp?pickLine(bp,B,false):'')+'</div>';
        } else {
          inner='<div class="cmp-missing">Comparison not written yet for '+esc(A.name)+' vs '+esc(B.name)+'.</div>';
        }
        return '<div class="cmp"><div class="cmp-h">'+esc(A.name)+' vs '+esc(B.name)+'</div>'+inner+'</div>';
      }).join('');
      $('.sl-stacks').innerHTML='<div class="sb">'+blocks+'</div>';
    }

    function renderAll(){ renderCols(); renderCamber(); renderStacks(); }

    /* ---------- interactions ---------- */
    root.addEventListener('change',function(e){
      var s=e.target.closest('select'); if(!s)return;
      if(s.dataset.slot!=null){ var i=+s.dataset.slot; slots[i]=s.value;
        if(SKIS[slots[i]].sizes.indexOf(len[i])<0) len[i]=midSize(slots[i]);
        renderAll(); }
      else if(s.dataset.len!=null){ var j=+s.dataset.len; len[j]=+s.value; renderCols(); renderStacks(); }
    });
    var resetBtn=$('.sl-reset');
    if(resetBtn) resetBtn.addEventListener('click',function(){
      slots=DEF.slice(0,3); len=slots.map(midSize); renderAll();
    });

    /* image fallbacks (shared, id-safe) */
    window.__slImgFB=window.__slImgFB||function(img){
      var fbs=(img.dataset.fb||'').split('|').filter(Boolean);
      if(fbs.length){ img.src=fbs.shift(); img.dataset.fb=fbs.join('|'); return; }
      var box=img.parentElement; img.remove();
      if(box && !box.querySelector('.ph')){ var d=document.createElement('div'); d.className='ph'; d.textContent='image unavailable'; box.appendChild(d); }
    };
    window.__slCamFB=window.__slCamFB||function(img){
      var box=img.parentElement; img.remove();
      if(box && !box.querySelector('.camph')){ var d=document.createElement('div'); d.className='camph';
        d.innerHTML='<span>'+(box.dataset.profdesc||'')+'</span>'; box.appendChild(d); }
    };

    /* ---------- close-ups: synced auto-pan + hover zoom ---------- */
    var ZOOM=1.5, EPS=0.004;
    var clamp01=function(v){return Math.min(1,Math.max(0,v));};
    var cuHover={}, cuS={};
    root.addEventListener('mousemove',function(e){ var cu=e.target.closest('[data-cu]'); if(!cu)return;
      var r=cu.getBoundingClientRect();
      cuHover[+cu.dataset.cu]={x:clamp01((e.clientX-r.left)/r.width), y:clamp01((e.clientY-r.top)/r.height)}; });
    root.addEventListener('mouseout',function(e){ var cu=e.target.closest('[data-cu]'); if(!cu)return;
      if(!cu.contains(e.relatedTarget)) delete cuHover[+cu.dataset.cu]; });

    var easeIO=function(x){return x<0.5?2*x*x:1-Math.pow(-2*x+2,2)/2;};
    var tri=function(x){var m=x%1;return m<0.5?m*2:2-m*2;};
    var phase=0, last=performance.now();
    function loop(now){
      var dt=Math.min(0.05,(now-last)/1000); last=now;
      if(!RM) phase=(phase+dt*0.03)%1;
      var gf=RM?0:easeIO(tri(phase*2));
      root.querySelectorAll('[data-cu]').forEach(function(cu){
        var i=+cu.dataset.cu, img=cu.querySelector('img'); if(!img)return;
        /* force true-aspect sizing inline (beats theme img rules + lazyload width:100%) */
        img.style.setProperty('height','185%','important');
        img.style.setProperty('width','auto','important');
        img.style.setProperty('max-width','none','important');
        img.removeAttribute('data-sizes'); img.removeAttribute('sizes');
        var st=cuS[i]||(cuS[i]={s:1,fx:.5,fy:gf,locked:true});
        var h=cuHover[i];
        if(h){ st.locked=false; var k=RM?1:Math.min(1,dt*10);
          st.s+=(ZOOM-st.s)*k; st.fx+=(h.x-st.fx)*k; st.fy+=(h.y-st.fy)*k;
        } else if(st.locked){ st.s=1; st.fx=.5; st.fy=gf;
        } else { var k2=RM?1:Math.min(1,dt*7);
          st.s+=(1-st.s)*k2; st.fx+=(.5-st.fx)*k2; st.fy+=(gf-st.fy)*k2;
          if(Math.abs(st.s-1)<EPS && Math.abs(st.fx-.5)<EPS && Math.abs(st.fy-gf)<EPS) st.locked=true; }
        var W=img.offsetWidth*st.s, H=img.offsetHeight*st.s;
        var rx=W-cu.offsetWidth, ry=H-cu.offsetHeight;
        var tx = rx>0 ? -rx*st.fx : -rx/2;
        var ty = ry>0 ? -ry*st.fy : -ry/2;
        img.style.transform='translate('+tx.toFixed(1)+'px,'+ty.toFixed(1)+'px) scale('+st.s.toFixed(3)+')';
      });
      requestAnimationFrame(loop);
    }

    renderAll();
    requestAnimationFrame(loop);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
